import { Component, EventEmitter, Output, inject } from '@angular/core';
import { ModuleManagerService } from '../../services/module-manager.service';
import { INavigationItem } from '../../model/i-navigation-item';
import { ModuleEntryPointDefinition } from '../../model/module-entry-point-definition';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { ModuleIconComponent } from '../module-icon/module-icon.component';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';

@Component({
   selector: 'asc-settings-menu',
   templateUrl: './settings-menu.component.html',
   styleUrls: ['./settings-menu.component.scss'],
   imports: [
      CommonModule,
      FormsModule,
      MatListModule,
      MatMenuModule,
      ModuleIconComponent
   ]
})
export class SettingsMenuComponent {
   private moduleManagerService = inject(ModuleManagerService);

   @Output() public itemSelected = new EventEmitter();
   public activeEntryPoint?: ModuleEntryPointDefinition;

   public get settingsNavigationItems(): INavigationItem[] {
      return this.moduleManagerService.settingsNavigationItems;
   }

   public navigateTo(entryPoint: ModuleEntryPointDefinition) {
      this.activeEntryPoint = entryPoint;
      this.itemSelected.emit();
      entryPoint?.navigate();
   }

   public isActive(navigationItem: INavigationItem): boolean {
      return this.moduleManagerService.isSettingsNavigationItemActive(navigationItem.id);
   }
}
